var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_17075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4924 7.54967C14.8699 7.73141 14.8699 8.26894 14.4924 8.45067L3.83648 13.5813C3.42847 13.7778 2.99034 13.374 3.1529 12.9513L4.91912 8.35915C5.00799 8.12808 5.00799 7.87226 4.91912 7.64119L3.1529 3.04902C2.99034 2.62636 3.42847 2.22258 3.83648 2.41903L14.4924 7.54967Z",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_17075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentMessage);
export default __webpack_public_path__ + "static/media/sentMessage.32ab02ba8d3bef6f270e1046a6b91623.svg";
export { ForwardRef as ReactComponent };